const techs = [
    {
        image: '/images/stacks/ReactJS.png',
        name: 'ReactJS'
    },

    {
        image: '/images/stacks/HTML5.png',
        name: 'HTML5'
    },

    {
        image: '/images/stacks/CSS3.png',
        name: 'CSS3'
    },

    {
        image: '/images/stacks/JavaScript.png',
        name: 'JavaScript'
    },

    {
        image: '/images/stacks/Sass.png',
        name: 'SASS'
    },

    {
        image: '/images/stacks/Bootstrap.png',
        name: 'Bootstrap'
    },

    {
        image: '/images/stacks/Nextjs.png',
        name: 'NextJS'
    },

    {
        image: '/images/stacks/Tailwindcss.png',
        name: 'Tailwind CSS'
    },

    {
        image: '/images/stacks/Figma.png',
        name: 'Figma'
    },

    {
        image: '/images/stacks/ReactJS.png',
        name: 'ReactJS'
    },

    {
        image: '/images/stacks/HTML5.png',
        name: 'HTML5'
    },

    {
        image: '/images/stacks/CSS3.png',
        name: 'CSS3'
    },

    {
        image: '/images/stacks/JavaScript.png',
        name: 'JavaScript'
    },

    {
        image: '/images/stacks/Sass.png',
        name: 'SASS'
    },

    {
        image: '/images/stacks/Bootstrap.png',
        name: 'Bootstrap'
    },

    {
        image: '/images/stacks/Nextjs.png',
        name: 'NextJS'
    },

    {
        image: '/images/stacks/Tailwindcss.png',
        name: 'Tailwind CSS'
    },

    {
        image: '/images/stacks/Figma.png',
        name: 'Figma'
    }
]

export default techs;